module.exports = __webpack_public_path__ + "img/contact.833c1e26.jpg";